// src/components/DominosOfferModal.jsx
import React, { useEffect, useState, useRef } from "react";
import {
    Dialog,
    IconButton,
    Box,
    Typography,
    Button,
    Fab,
    useMediaQuery,
} from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { CopyToClipboard } from "react-copy-to-clipboard";

import {
    dominosModelImage1,
    dominosModelImage2,
    dominosModelImage3,
    dominosModelImage4,
    dominosModelMobileImage1,
    dominosModelMobileImage2,
    dominosModelMobileImage3,
    dominosModelMobileImage4,
    offericon,
    useSelector,
} from "../../imports/generalImport";
import { actionNotifier } from "../tostify";

const DominosOfferModal = () => {
    const ProductDetail = useSelector((state) => state.ProductDetail?.allData);

    const [open, setOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [copied, setCopied] = useState(false);
    const swiperRef = useRef(null);
    const isMobile = useMediaQuery("(max-width:600px)");

    useEffect(() => {
        setOpen(true);
    }, []);

    const handleClose = () => setOpen(false);
    const handleOpen = () => {
        setActiveIndex(0);
        setOpen(true);
    };

    const offers = [
        {
            id: 1,
            title: "50% OFF on First Order",
            img: isMobile ? dominosModelMobileImage1 : dominosModelImage1,
            nextText: isMobile ? "Next" : "click next for coupon code",
            prevText: "Back",
            isCouponCode: false
        },
        {
            id: 2,
            title: "Buy 1 Get 1 Free",
            img: isMobile ? dominosModelMobileImage2 : dominosModelImage2,
            nextText: isMobile ? "Next" : "click next for coupon code",
            prevText: "Back",
            isCouponCode: false
        },
        {
            id: 3,
            title: "Buy 1 Get 1 Free",
            img: isMobile ? dominosModelMobileImage3 : dominosModelImage3,
            nextText: isMobile ? "Next" : "click next for coupon code",
            prevText: "Back",
            isCouponCode: false
        },
        {
            id: 4,
            title: "Free Delivery on Orders Above ₹499",
            img: isMobile ? dominosModelMobileImage4 : dominosModelImage4,
            nextText: isMobile ? "Next" : "Buy Domino's Gift Card",
            prevText: "Back",
            isCouponCode: true
        },
    ];

    const handleCopyCode = () => {
        actionNotifier.info("Coupon Code Copied!", {
            position: "top-right",
            autoClose: 600,
            theme: "dark",
            hideProgressBar: "true"
        });
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth={false}
                PaperProps={{
                    sx: {
                        width: { xs: "100vw", sm: "60%" },
                        height: { xs: "60vh", sm: "90%", xl: '70%' },
                        borderRadius: 3,
                        overflow: "hidden",
                        position: "relative",
                        zIndex: 3000,
                        top: -30,
                    },
                }}
            >
                {/* Close Button */}
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 12,
                        top: 12,
                        backgroundColor: "rgba(0,0,0,0.6)",
                        color: "#fff",
                        "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
                        zIndex: 2000,
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {/* Swiper Slider */}
                <Box sx={{
                    width: "100%", height: "100%", position: "relative",
                }}>
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={1}
                        loop={false}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        onSlideChange={(swiper) => {
                            setActiveIndex(swiper.activeIndex);
                            setCopied(false); // reset copy status
                        }}
                        style={{ width: "100%", height: "100%" }}
                    >
                        {offers.map((offer) => {
                            return (
                                <SwiperSlide key={offer.id}>
                                    <Box
                                        sx={{
                                            width: "100%",
                                            height: "100%",
                                            position: "relative",

                                        }}
                                    >
                                        <Box
                                            component={'img'}
                                            src={offer.img}
                                            alt={offer.title}
                                            sx={{
                                                width: "100%",
                                                height: "100%",
                                            }}
                                        />

                                        {offer?.id === 4 && (
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    // bottom: { xs: '45px', md: '30px' },
                                                    top: { xs: '52%', md: '55%' },
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {/* Coupon Code Box */}
                                                <Box
                                                    sx={{
                                                        width: {
                                                            xs: 210,
                                                            md: 230
                                                        },
                                                        height: 40,
                                                        backgroundColor: '#d70101',
                                                        borderRadius: 3,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-evenly',
                                                        color: '#fff',
                                                        fontWeight: 'bold',
                                                    }}
                                                >
                                                    <Typography variant="h5">DONIMOXXXX</Typography>
                                                    <Box>
                                                        <CopyToClipboard
                                                            text={ProductDetail?.couponCodes}
                                                            onCopy={() => handleCopyCode()}
                                                        >
                                                            <IconButton size="large" sx={{ color: 'white.main' }}>
                                                                <ContentCopyIcon fontSize="large" />
                                                            </IconButton>
                                                        </CopyToClipboard>
                                                    </Box>
                                                </Box>

                                                {/* Terms & Conditions */}
                                                <Box sx={{ width: '100%', maxWidth: 400 }}>
                                                    <Typography
                                                        variant="h6"
                                                        sx={{
                                                            textAlign: 'center',
                                                            mb: 1,
                                                            color: 'white.main',
                                                        }}
                                                    >
                                                        Terms and Conditions :
                                                    </Typography>

                                                    <Box
                                                        component="ul"
                                                        sx={{
                                                            color: 'white.main',
                                                            fontWeight: 400,
                                                            fontSize: { xs: '0.85rem', md: '1rem' },
                                                            lineHeight: 1.4,
                                                            listStyleType: 'disc',
                                                            pl: 2,
                                                            m: 0,
                                                        }}
                                                    >
                                                        {ProductDetail?.couponCode_termss
                                                            ?.split('\n') // 🔥 only break at new line
                                                            .map((point, index) =>
                                                                point.trim() ? (
                                                                    <Box
                                                                        key={index}
                                                                        component="li"
                                                                        sx={{
                                                                            mb: 0.5,
                                                                            wordBreak: 'break-word',
                                                                        }}
                                                                    >
                                                                        {point.trim()}
                                                                    </Box>
                                                                ) : null
                                                            )}
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )}

                                    </Box>
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>

                    {/* Back button */}
                    {activeIndex > 0 && (
                        <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            startIcon={<ArrowBackIcon />}
                            onClick={() => swiperRef.current?.slidePrev()}
                            sx={{
                                position: "absolute",
                                top: { xs: "95%", md: "95%" },
                                left: { xs: 8, md: 16 },
                                transform: "translateY(-50%)",
                                color: "#fff",
                                textTransform: "none",
                                zIndex: 2000,
                                fontSize: { xs: "10px", md: "16px" },
                                fontWeight: { xs: 400, md: 500 },
                            }}
                        >
                            {offers[activeIndex]?.prevText}
                        </Button>
                    )}

                    {/* Next button */}
                    {activeIndex < offers.length - 1 && (
                        <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            endIcon={<ArrowForwardIcon />}
                            onClick={() => swiperRef.current?.slideNext()}
                            sx={{
                                position: "absolute",
                                top: { xs: "95%", md: "95%" },
                                right: { xs: 8, md: 16 },
                                transform: "translateY(-50%)",
                                color: "#fff",
                                textTransform: "none",
                                zIndex: 2000,
                                fontSize: { xs: "10px", md: "16px" },
                                fontWeight: { xs: 400, md: 500 },
                            }}
                        >
                            {offers[activeIndex]?.nextText}
                        </Button>
                    )}
                </Box>
            </Dialog>

            {/* Floating Button (when modal closed) */}
            {!open && (
                <Fab
                    color="default"
                    onClick={handleOpen}
                    sx={{
                        position: "fixed",
                        bottom: { xs: '25vh', md: 20 },
                        right: { xs: 20, md: 20 },
                        width: { xs: 70, md: 70 },
                        height: { xs: 70, md: 70 },
                        borderRadius: "50%",
                        zIndex: 1400,
                        backgroundColor: 'transparent'
                    }}
                >
                    <img
                        src={offericon}
                        alt="Offers"
                        style={{ width: "100%", height: "100%", borderRadius: "50%", backgroundColor: 'transparent' }}
                    />
                </Fab>
            )}
        </>
    );
};

export default DominosOfferModal;